import { environment } from '../../environments/environment';

export const locale = {
    lang: 'pt',
    data: {
        APP: {
            TITLE: environment.titleBase,
            SOCKET: {
                DISCONNECT: 'Você foi desconectado',
                OFFLINE: 'Você não possui conexão com a internet',
                RECONNECTING: 'Reconectando...',
                RECONNECT: 'Reconectar',
            },
            PUSH_NOTIFICATION: {
                REQUEST_PERMISSION: {
                    TITLE: 'Ative as notificações',
                    MESSAGE: 'Ative as notificações do navegador para receber alertas.',
                },
                BUTTONS: {
                    ALLOW: 'Habilitar',
                    CANCEL: 'Cancelar',
                },
            },
            MODAL: {
                FEATURES: {
                    TITLE: 'Novidades',
                    BUTTONS: {
                        READ_LATER: 'Ver mais tarde',
                        OK: 'Ok entendi',
                        READ_ALL: 'Ler todas',
                    },
                },
                SEARCH_ORDER: {
                    TITLE: 'Buscar pedido',
                    BUTTONS: {
                        SEARCH: 'Buscar',
                        CANCEL: 'Cancelar',
                    },
                },
                PEOPLE: {
                    TITLE: 'Buscar pessoa',
                    BUTTONS: {
                        CANCEL: 'Cancelar',
                    },
                },
                CHUNK_ERROR: {
                    TITLE: 'Atualização disponível',
                    DESCRIPTION: 'Realizamos uma atualização no sistema e é necessário recarregar a pagina.',
                    BUTTONS: {
                        CONFIRM: 'Ok, recarregar',
                    },
                },
                LABORATORY_CHANGED: {
                    TITLE: 'Sessão alterada',
                    DESCRIPTION: 'Detectamos que o laboratório ou a conta logada foi alterado.<br>Recarregue a página para continuar.',
                    BUTTONS: {
                        CONFIRM: 'Recarregar',
                    },
                },
            },
        },
    },
};
